import { create } from 'zustand';

type BreadcrumbItem = {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  href?: string;
  onClick?: () => void;
};

export type NavigationStore = {
  title?: React.ReactNode;
  breadcrumb?: BreadcrumbItem[];
  setPageHeader: (
    params: Pick<NavigationStore, 'breadcrumb' | 'title'>
  ) => void;
};

export const useNavigationStore = create<NavigationStore>((set) => ({
  title: undefined,
  breadcrumb: undefined,
  setPageHeader: ({ title, breadcrumb }) => set({ title, breadcrumb }),
}));
